import { Component, ElementRef, ViewChild } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DialogBaseComponent, DialogParams } from "@/shared/dialog-base.component";
import { DomainService } from "@/shared/domain.service";
import { JobOrderExplainApiService, JobOrderExplainResultDTO } from "@/shared/job-order-explain-api.service";
import { UtilFns } from "@/shared/util-fns";

export interface ExplainJobOrderDialogParams extends DialogParams {
  joHeaderId: number;
}

@Component({
  templateUrl: "./explain-job-order-dialog.component.html",
  standalone: false,
})
export class ExplainJobOrderDialogComponent extends DialogBaseComponent<ExplainJobOrderDialogParams> {
  @ViewChild("firstInput") firstInput: ElementRef<HTMLInputElement>;

  question = "";
  isExplaining = false;
  result: JobOrderExplainResultDTO | null = null;
  errorMessage: string | null = null;

  constructor(
    config: DynamicDialogConfig<ExplainJobOrderDialogParams>,
    dialogRef: DynamicDialogRef,
    domainService: DomainService,
    private explainApi: JobOrderExplainApiService,
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: `Explain Job Order ${this.params.joHeaderId}`,
      width: "800px",
      height: "auto",
    });
    this.prepare();
  }

  async prepare() {
    this.isPageReady = true;
    await UtilFns.wait(1);
    this.firstInput?.nativeElement?.focus();
    await this.explain();
  }

  async explain() {
    if (this.isExplaining) return;
    this.isExplaining = true;
    this.errorMessage = null;
    try {
      this.result = await this.explainApi.explain(this.params.joHeaderId, this.question.trim() || null);
    } catch (e) {
      this.result = null;
      const serverMessage = e instanceof HttpErrorResponse && e.status === 400 ? e.error?.Message : null;
      this.errorMessage = `The assistant cannot explain this job order. ${serverMessage ?? "Try again later."}`;
    } finally {
      this.isExplaining = false;
    }
  }

  close() {
    this.dialogRef.close();
  }
}
